import React, { useState, useEffect } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { isEmpty } from "lodash";
import ErrorBoundary from "components/ErrorBoundary";
import SearchContainer from "./components/SearchContainer";
import LocationTable from "./components/LocationTable";
import useAxios from "hooks/useAxios";
import { onExport, getUpdatedFilter } from "utils/helper";
import { useLocation } from "react-router-dom";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const initialFilterBySearch = {
  coveredEntityName: "",
};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "modifiedDate",
  order: "desc",
  filters: [],
};

let selectedCoveredEntity = {};

const Location = (props) => {
  const { orgId } = props;
  const API = useAxios();
  const location = useLocation();
  let selectedCEId = window.selectedCoveredEntittyId;
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  let { tenantID, coveredEntityID } = selectedCoveredEntity;
  const [colFilter, setColFilter] = useState([]);
  const [resetFlag, SetResetFlag] = useState(false);

  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: "",
    coveredId: "",
    records: 0,
    reset: false,
  });
  const [researchNeededCount, setResearchNeededCount] = useState(0);
  const [eligibleCount, setEligibleCount] = useState(0);
  const [pageSize, SetpageSize] = useState(initialFilters)
  const [inEligibleCount, setInEligibleCount] = useState(0);

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "modifiedDate",
      order: "desc",
      filters: [],
    };
    setState({ data: [], records: 0 });
    selectedCoveredEntity = {};
  }, []);

  // const fetchLocations = async (pageDetails = {}, hasColumnFilter) => {
  //   debugger;
  //   let filter = { ...pageDetails };
  //   if (hasColumnFilter) {
  //     filter.filters = [...initialFilters.filters, ...pageDetails.filters];
  //     initialFilters.filters = [...initialFilters.filters];
  //   } else {
  //     initialFilters = { ...initialFilters, ...filter };
  //   }
  //   let { tenantID, coveredEntityID } = selectedCoveredEntity;
  //   console.log(coveredEntityID, "id");
  //   if (coveredEntityID) {
  //     try {
  //       let countData = await API.get(
  //         `/${tenantID}/CEServiceLocation/geteligibilityforce/${coveredEntityID}`
  //       );
  //       if (countData) {
  //         let result = countData.data;
  //         setResearchNeededCount(result.researchNeededCount);
  //         setEligibleCount(result.eligibleCount);
  //         setInEligibleCount(result.inEligibleCount);
  //       }
  //       setState({ loading: true });

  //       const { data } = await API.post(
  //         `/${tenantID}/CEServiceLocation/All/${coveredEntityID}`,
  //         filter
  //       );
  //       if (data) {
  //         setState({
  //           data: data.items,
  //           records: data.totalRecords,
  //           loading: false,
  //         });
  //       } else {
  //         setState({
  //           data: [],
  //           records: 0,
  //           loading: false,
  //         });
  //       }
  //     } catch (error) {
  //       setState({ loading: false, data: [], records: 0 });
  //     }
  //   }
  // };

  const fetchLocations = async (pageDetails = {}, hasColumnFilter) => {
    let filter = { ...pageDetails };

    // ✅ Manage filters safely (no mutation)
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      initialFilters.filters = [...initialFilters.filters];
      initialFilters.order = pageDetails.order;
      initialFilters.orderBy = pageDetails.orderBy;
    } else {
      initialFilters = { ...initialFilters, ...pageDetails };
    }

    const { tenantID, coveredEntityID } = selectedCoveredEntity;
    if (!coveredEntityID || !tenantID) return;

    // ✅ Start loading once at the beginning
    setState((prev) => ({ ...prev, loading: true }));

    try {
      // ✅ Run both APIs in parallel
      const [countData, listData] = await Promise.all([
        API.get(
          `/${tenantID}/CEServiceLocation/geteligibilityforce/${coveredEntityID}`
        ),
        API.post(
          `/${tenantID}/CEServiceLocation/All/${coveredEntityID}`,
          filter
        ),
      ]);

      // ✅ Update counts
      if (countData?.data) {
        const result = countData.data;
        setResearchNeededCount(result.researchNeededCount);
        setEligibleCount(result.eligibleCount);
        setInEligibleCount(result.inEligibleCount);
      }

      // ✅ Update table data
      if (listData?.data) {
        setState({
          data: listData.data.items,
          records: listData.data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setState({
        loading: false,
        data: [],
        records: 0,
      });
    }
    SetpageSize(filter.pageSize)
  };

  const onSearchLocation = async (filters) => {
    const { coveredEntityName, eligibleFlag } = filters;
    initialFilters = {
      currentPage: initialFilters.currentPage,
      pageSize: initialFilters.pageSize,
      orderBy: initialFilters.orderBy,
      order: initialFilters.order,
      filters: [],
    };

    if (coveredEntityName && !isEmpty(coveredEntityName)) {
      initialFilters.filters = getUpdatedFilter(
        "coveredEntityID",
        parseInt(coveredEntityName),
        initialFilters
      );
    }
    if (eligibleFlag != "-1") {
      initialFilters.filters = getUpdatedFilter(
        'ISNULL(eligibleFlag,"")',
        eligibleFlag,
        initialFilters
      );
    }
    initialFilters.currentPage = 1;
    fetchLocations(initialFilters);
  };

  const onReset = () => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "modifiedDate",
      order: "desc",
      filters: [],
    };
    setState({ data: [], reset: !state.reset, records: 0 });
    selectedCoveredEntity = {};
    setResearchNeededCount(0);
    setInEligibleCount(0);
    setInEligibleCount(0);
    setEligibleCount(0);
    SetResetFlag(true);

  };

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/CEServiceLocation/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };
  const handleExport2 = async () => {
    var additionalCriteria = {};
    const mergedFiltersObj = {
      ...initialFilters,
      filters: [
        ...(initialFilters?.filters || []),
        ...(colFilter?.filters || []),
      ]
    };
    const datafilters = mergedFiltersObj.filters.filter((item) => {
      return (
        item.filterValue == ""
      )
    })
    if (datafilters.length > 0) {
      mergedFiltersObj.filters = getUpdatedFilter(
        "ISNULL(eligibleFlag,\"\")",
        (datafilters ? datafilters[0].filterValue : ""),
        mergedFiltersObj
      )
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;

    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "location";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(mergedFiltersObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchLocations(filter, true);
    } else {
      fetchLocations(filter);
    }
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    await fetchLocations(columnFilters, true);
    setColFilter(columnFilters);
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
  };

  const refetch = (hasReset) => {
    setColFilter([]);
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
        pageSize: pageSize,
      };
    }
    fetchLocations(initialFilters);
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  useEffect(() => {
    onReset()
  }, [orgId])
  return (
    <div>
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top" hidden={collapseSider}>
            <CardBody className="section-devider-border">
              <ErrorBoundary>
                <SearchContainer
                  initialValue={initialFilterBySearch}
                  onSearch={onSearchLocation}
                  orgId={orgId}
                  onReset={onReset}
                  handleUpdateEntity={handleUpdateEntity}
                  selectedCEId={selectedCEId}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>

        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <LocationTable
                data={state.data}
                loading={state.loading}
                onExport={handleExport2}
                filters={initialFilters}
                totalSize={state.records}
                onPageChange={onPageChange}
                coveredEntityID={selectedCoveredEntity?.coveredEntityID}
                tenantID={selectedCoveredEntity?.tenantID}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={state.reset}
                researchNeededCount={researchNeededCount}
                eligibleCount={eligibleCount}
                inEligibleCount={inEligibleCount}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                resetFlag={resetFlag}
                SetResetFlag={SetResetFlag}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Location;
